import type { Holiday } from "@shared/models/holiday"
import type { PlanbookDateAnnotation } from "@shared/models/planbook"
import { objectId } from "@shared/util/object-id"
import { merge } from "lodash-es"

export function convertHolidayToPlanbookDateAnnotation(holiday: Holiday): PlanbookDateAnnotation {
  let type =
    holiday.attributes.startDate === holiday.attributes.endDate
      ? "date-annotation-planbook-custom-single"
      : "date-annotation-planbook-custom-range"

  let baseAttributes = {
    title: holiday.attributes.title,
    isOff: holiday.attributes.isOff,
    isPublic: true,
    description: null,
  }

  return holiday.attributes.startDate === holiday.attributes.endDate
    ? {
        id: objectId(),
        type: "date-annotation-planbook-custom-single",
        attributes: merge(baseAttributes, {
          dateString: holiday.attributes.startDate,
        }),
      }
    : {
        id: objectId(),
        type: "date-annotation-planbook-custom-range",
        attributes: merge(baseAttributes, {
          startDate: holiday.attributes.startDate,
          endDate: holiday.attributes.endDate,
          publishedByGroupId: null,
        }),
      }
}
